import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        setainushi:{
            age:null,
            shokugyou:null,
            geshuu:null,
            bonus: null,
            retirementAge:null,
            chochiku:null,
        },
        haiguusha:{
            ari:null,
            age:null,
            shokugyou:null,
            geshuu:null,
            bonus: null,
            retirementAge:null,
        },
        okosama:{
            ninzuu:null,
            ages:[],
        },
        osumai:{
            plan: 1,
            juukyohi:null,
            loan:null,
            bonus: null,
            kinri: 1.000,
            kikan: null,
            jikoshikin: null,
            shikinEnjo: null,
        },
    },
    getters: {
        setainushiNenshu (state) {
            return state.setainushi.geshuu * 12 + state.setainushi.bonus*1;
        },
        haiguushaNenshu (state) {
            return state.haiguusha.geshuu * 12 + state.haiguusha.bonus*1;
        },
        //世帯年収（手取りペース）世帯主と配偶者の月収 x 12
        setaiNenshu (state, getters) {
            return getters.setainushiNenshu + getters.haiguushaNenshu;
        },
        //お子様の有無に合わせて年齢のデータを返す
        okosamaAges (state) {
            return state.okosama.ages.map(ages=>{
                if (ages.born == 2) {
                    return {'age':ages.age * -1, 'school':ages.school};
                }
                else {
                    return {'age':ages.age * 1, 'school':ages.school};
                }
           });
        },
        setaiNinzu (state) {
            let ninzu = 1; //世帯主

            //配偶者
            if (state.haiguusha.ari) { //1:配偶者あり、0:配偶者なし
                ninzu += 1;
            }

            //子供
            ninzu += state.okosama.ninzuu*1;

            return ninzu;
        },
        mochiieLoanPaymentPerYear(state) {
            let byMonth = state.osumai.loan * 12;
            return byMonth + state.osumai.bonus*1;
        },
        queryParams (state) {
            // return 'p1q140q21q340q465q5100p2q11q240q34q4q5p3q11q22q3c1_1c1_2c2_2p4q11q210q313';
            let params = {};

            let qs = []; //questions
            //setainushi
            ['age', 'shokugyou', 'geshuu', 'bonus', 'retirementAge', 'chochiku'].forEach((q, idx)=>{
                // console.log(idx, q);
                let value = state.setainushi[q];
                if (value === null || value === undefined) {
                    value = '';
                }
                qs.push( '' + (idx+1) + value ); //数値が文字列連携でなく、数値として加算されてしまうので、''+ で文字列連結としている
            });
            params.setainushi = qs;

            //haiguusha
            qs = [];
            ['ari','age','shokugyou','geshuu','bonus','retirementAge'].forEach((q, idx)=>{
                // console.log(idx, q);
                let value = state.haiguusha[q];
                if (value === null || value === undefined) {
                    value = '';
                }
                qs.push( '' + (idx+1) + value ); //数値が文字列連携でなく、数値として加算されてしまうので、''+ で文字列連結としている
            });
            params.haiguusha = qs;

            //okosama
            qs = [];
            ['ninzuu'].forEach((q, idx)=>{
                // console.log(idx, q);
                let value = state.okosama[q];
                if (value === null || value === undefined) {
                    value = '';
                }
                qs.push( '' + (idx+1) + value ); //数値が文字列連携でなく、数値として加算されてしまうので、''+ で文字列連結としている
            });
            //okosama.ages
            //qValue = c1_1_2c1_2_2c2_2_1
            let cValues = [];
            state.okosama.ages.forEach(child=>{
                let str = [];
                ['age', 'born', 'school'].forEach(q=>{
                    let value = child[q];
                    if (value === null || value === undefined) {
                        value = '';
                    }
                    str.push(value);
                });
                cValues.push(str.join('_'));
            });
            qs.push( '' + '2c' + cValues.join('c') );

            params.okosama = qs;

            //osumai
            qs = [];
            ['loan', 'bonus', 'kinri', 'kikan', 'jikoshikin', 'shikinEnjo'].forEach((q, idx)=>{
                // console.log(idx, q);
                let value = state.osumai[q];
                if (value === null || value === undefined) {
                    value = '';
                }
                qs.push( '' + (idx+1) + value ); //数値が文字列連携でなく、数値として加算されてしまうので、''+ で文字列連結としている
            });
            params.osumai = qs;


            return params;
            // return {setainushi:[140,21,340,4,5]};
        }
    },
    mutations: {
        setSetainushi(state,data){
            state.setainushi.age = data.age;
            state.setainushi.shokugyou = data.shokugyou;
            state.setainushi.geshuu = data.geshuu;
            state.setainushi.bonus = data.bonus;
            state.setainushi.retirementAge = data.retirementAge;
            state.setainushi.chochiku = data.chochiku;

        },
        setHaiguusha(state,data){
            state.haiguusha.ari = data.ari;
            state.haiguusha.age = data.age;
            state.haiguusha.shokugyou = data.shokugyou;
            state.haiguusha.geshuu = data.geshuu;
            state.haiguusha.bonus = data.bonus;
            state.haiguusha.retirementAge = data.retirementAge;

        },
        setOkosama(state,data){
            state.okosama.ninzuu = data.ninzuu;
            state.okosama.ages = data.ages;
        },
        setOsumai(state,data){
            state.osumai.plan = data.plan;
            state.osumai.juukyohi = data.juukyohi;
            state.osumai.loan = data.loan;
            state.osumai.bonus = data.bonus;
            state.osumai.kinri = data.kinri
            state.osumai.kikan = data.kikan
            state.osumai.jikoshikin = data.jikoshikin
            state.osumai.shikinEnjo = data.shikinEnjo
        },
        setSetainushiFromQueryParameters(state, params) {
            // console.log(params);
            if (!Array.isArray(params)) {
                return;
            }
            params.forEach( q => {
                let qNo = q.substr(0,1); //1文字目は、質問番号
                let qValue = q.substr(1); //2文字目以降は、回答値
                // console.log(qNo, qValue);
                switch (qNo) {
                    case '1':
                        state.setainushi.age = qValue;
                        break;
                    case '2':
                        state.setainushi.shokugyou = qValue;
                        break;
                    case '3':
                        state.setainushi.geshuu = qValue;
                        break;
                    case '4':
                        state.setainushi.bonus = qValue;
                        break;
                    case '5':
                        if (qValue === '0') { //退職予定なしは、文字列の 0 で渡ってくるので、数値の0で設定する
                            qValue = 0;
                        }
                        state.setainushi.retirementAge = qValue;
                        break;
                    case '6':
                        state.setainushi.chochiku = qValue;
                        break;
                }
            });


        },
        setHaiguushaFromQueryParameters(state, params) {
            if (!Array.isArray(params)) {
                return;
            }
            params.forEach( q => {
                let qNo = q.substr(0,1); //1文字目は、質問番号
                let qValue = q.substr(1); //2文字目以降は、回答値
                // console.log(qNo, qValue);
                switch (qNo) {
                    case '1':
                        state.haiguusha.ari = qValue;
                        break;
                    case '2':
                        state.haiguusha.age = qValue;
                        break;
                    case '3':
                        state.haiguusha.shokugyou = qValue;
                        break;
                    case '4':
                        state.haiguusha.geshuu = qValue;
                        break;
                    case '5':
                        state.haiguusha.bonus = qValue;
                        break;
                    case '6':
                        if (qValue === '0') { //退職予定なしは、文字列の 0 で渡ってくるので、数値の0で設定する
                            qValue = 0;
                        }
                        state.haiguusha.retirementAge = qValue;
                        break;
                }
            });
        },
        setOkosamaFromQueryParameters(state, params) {
            if (!Array.isArray(params)) {
                return;
            }
            params.forEach( q => {
                let qNo = q.substr(0,1); //1文字目は、質問番号
                let qValue = q.substr(1); //2文字目以降は、回答値
                // console.log(qNo, qValue);

                if(qNo === '1') {
                    state.okosama.ninzuu = qValue;
                }else if(qNo === '2') {
                    //この時点でqValue = c1_1c1_2c2_2
                    let okosamaParams = qValue.split('c');

                    //お子様の入力がなければ終了（空文字だけの配列が帰ってくる）
                    //okosamaParams = ['', '1_1', '1_2', '2_2']
                    if (!Array.isArray(okosamaParams) || okosamaParams.length === 1 ) {
                        state.okosama.ages = [];
                    }

                    let agesArray = [];

                    okosamaParams.forEach(ageParam => {
                        //ageParam = 1_1
                        if (!ageParam) {
                            return;
                        }

                        let ageSeparateParam = ageParam.split('_');
                        let ageObject = {
                            age:ageSeparateParam[0],
                            born:ageSeparateParam[1],
                            school: ageSeparateParam[2],
                        }

                        agesArray.push(ageObject);
                    });

                    state.okosama.ages = agesArray;
                }
            });

        },
        setOsumaiFromQueryParameters(state, params) {
            if (!Array.isArray(params)) {
                return;
            }
            params.forEach( q => {
                let qNo = q.substr(0,1); //1文字目は、質問番号
                let qValue = q.substr(1); //2文字目以降は、回答値
                // console.log(qNo, qValue);
                switch (qNo) {
                    case '1':
                        state.osumai.loan = qValue;
                        break;
                    case '2':
                        state.osumai.bonus = qValue;
                        break;
                    case '3':
                        state.osumai.kinri = qValue;
                        break;
                    case '4':
                        state.osumai.kikan = qValue;
                        break;
                    case '5':
                        state.osumai.jikoshikin = qValue;
                        break;
                    case '6':
                        state.osumai.shikinEnjo = qValue;
                        break;

                }
            });
        }

    },
    plugins: [createPersistedState({
        key: 'sumaiLifeNavi',
        storage: window.sessionStorage
    })],
})